//巡检员管理
const Charge = () => import(/*webpackChunkName:'operation'*/'@/page/operation/inspectorManagement/charge.vue')
const Attendance = () => import(/*webpackChunkName:'operation'*/'@/page/operation/inspectorManagement/attendance.vue')
const Handset = () => import(/*webpackChunkName:'operation'*/'@/page/operation/inspectorManagement/handset.vue')
// const Finance = () => import(/*webpackChunkName:'operation'*/'@/page/operation/inspectorManagement/finance1.vue')
// const ArrearsStatistics = () => import(/*webpackChunkName:'operation'*/'@/page/operation/inspectorManagement/arrearsStatistics.vue')

const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const inspector={
    path: '/main/inspector',
    name: '巡检员管理',
    meta: {
        requireAuth: true,

    },
    component: RouteTemp,
    children: [{
        path: '/main/inspectorManagement',
        name: '巡检员管理',
        meta: {
            requireAuth: true,
        },
        component: Charge
    },
    {
        path: '/main/inspectorManagement/attendance',
        name: '考勤管理',
        meta: {
            requireAuth: true,
        },
        component: Attendance
    }, {
        path: '/main/inspectorManagement/informationFeedback',
        name: '巡检员信息反馈',
        meta: {
            requireAuth: true,
        },
        component: Handset
    }, 
    // {
    //     path: '/main/inspectorManagement/overviewOfFees',
    //     name: '巡检员收费概览',
    //     meta: {
    //         requireAuth: true,
    //     },
    //     component: Finance
    // },
    //  {
    //     path: '/main/inspectorManagement/arrearsStatistics',
    //     name: '月追缴列表',
    //     meta: {
    //         requireAuth: true,
    //     },
    //     component: ArrearsStatistics
    // }, 
    ]
}